import { Avatar, Chip, Grid } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { getI18n, useTranslation } from 'react-i18next'
import { formatHelsinkiDateTime } from '../../../common/dateHelper'
import { localizedLanguageName } from '../../../common/languageHelper'
import history from '../../../history'
import { IUserLanguage } from '../../../interfaces/language/ILanguage'
import { useStore } from '../../../Provider'
import { OPLoadingCircle } from '../../OPcomponents/OPLoadingcircle'
import '../../styles/grid.scss'
import '../profile.scss'

const Overview = (): JSX.Element => {
  const { t } = useTranslation()

  const rootStore = useStore()
  const { userProfileImage, validatedUser } = rootStore.loginStore
  const { sidebarUser } = rootStore.sidebarStore
  const { userObject, getUserOverview, loadingOverview } = rootStore.personStore

  useEffect(() => {
    getUserOverview(validatedUser)
  }, [getUserOverview, validatedUser])

  return (
    <>
      {!loadingOverview ? (
        <Grid container rowGap={2}>
          <Grid item xs={12} className='profile--pointer' onClick={() => history.push('/profile/overview')}>
            <p data-testid='title' className='profile--titlefont'>
              {sidebarUser.name}
            </p>
          </Grid>
          <Grid container data-testid='overviewId' spacing={2}>
            {/* Title & avatar row */}
            <Grid item xs={12} className='profile--pointer' onClick={() => history.push('/profile/overview')}>
              <Grid container justifyContent={'space-between'} className='griditem--negativemargin' wrap='nowrap'>
                <Grid item xs={12} md={8} className='profile--grid__titlepadding'>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <p className='profile--cert__headertext'>{t('Profile.ProfileTitle')}</p>
                    </Grid>
                    <Grid item xs={12}>
                      <p className='profile--deptext titleoverflow'>
                        {getI18n().language === 'en' && userObject?.titleEng && userObject?.titleEng !== ''
                          ? userObject.titleEng
                          : userObject?.titleFi && userObject?.titleFi !== ''
                          ? userObject.titleFi
                          : t('Profile.NoAddedTitle')}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item sx={{ alignSelf: 'flex-start' }}>
                  <Grid item sx={{ transform: 'translateY(-48px)' }}>
                    <Avatar className='profile--grid__profimage' src={`data:image/jpeg;base64,${userProfileImage}`} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {/* 2 x 2 info grid */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {/* Summary */}
                <Grid item xs={12} md={6} className='profile--grid__summary'>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <p className='profile--cert__headertext'>{t('Profile.ProfileSummary')}</p>
                    </Grid>
                    <Grid item xs={12}>
                      <p className='profile--deptext summaryoverflow'>
                        {getI18n().language === 'en' && userObject?.summaryEng && userObject?.summaryEng !== ''
                          ? userObject.summaryEng?.slice(0, 400)
                          : userObject?.summaryFi && userObject?.summaryFi !== ''
                          ? userObject.summaryFi?.slice(0, 400)
                          : t('Profile.NoAddedSummary')}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Work experience description */}
                <Grid item xs={12} md={6} className='profile--grid__summary'>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <p className='profile--cert__headertext'>{t('Profile.ProfileWorkExperienceDescription')}</p>
                    </Grid>
                    <Grid item xs={12}>
                      <p className='profile--deptext summaryoverflow'>
                        {getI18n().language === 'en' &&
                        userObject?.workExperienceDescriptionEng &&
                        userObject?.workExperienceDescriptionEng !== ''
                          ? userObject.workExperienceDescriptionEng?.slice(0, 400)
                          : userObject?.workExperienceDescriptionFi && userObject?.summaryFi !== ''
                          ? userObject.workExperienceDescriptionFi?.slice(0, 400)
                          : t('Profile.NoAddedWorkExperience')}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Languages */}
                <Grid item xs={12} md={6} className='profile--grid__languages'>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <div className='profile--cert__headertext lang'>{t('Language.Header')}</div>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={1}>
                        {userObject.languages?.slice(0, 10).map((lang: IUserLanguage) => (
                          <Grid item key={lang.languageId}>
                            <Chip
                              onClick={() => history.push('/profile/overview', lang.languageName)}
                              data-testid={lang.languageName}
                              size='small'
                              variant='outlined'
                              key={lang.languageId}
                              label={localizedLanguageName(lang.languageName, t)}
                              className='profile--langchip__chipstyling'
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {/* Last updated */}
                <Grid item xs={12} md={6} className='profile--grid__languages'>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <p className='profile--cert__headertext'>{t('Profile.ProfileLastEdited')}</p>
                    </Grid>
                    <Grid item xs={12}>
                      {userObject?.lastEdited && (
                        <p className='profile--deptext' data-testid='lastEdited'>
                          {formatHelsinkiDateTime(userObject.lastEdited, '')}
                        </p>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <OPLoadingCircle />
      )}
    </>
  )
}
export default observer(Overview)
